import ContactUs from 'components/ContactUs/ContactUs';
import WhyWorkersChooseJoblio from 'components/HeroComponents/WhyWorkersChooseJoblio';
import MediaAboutUs from 'components/MediaAboutUs/MediaAboutUs';
import MediaSection from 'components/MediaSection/MediaSection';
import { BUILT_BY_IMMIGRANTS_VIDEO_LINK } from 'components/MediaSection/constants';
import OurCLients from 'components/OurCLients/OurCLients';
import SplitScreen from 'components/SplitScreen';
import Testimonials from 'components/Testimonials/Testimonials';

const Home = () => {
  return (
    <>
      <SplitScreen />
      <WhyWorkersChooseJoblio
        componentToShowOnMobile={<OurCLients />}
        backgroundColor="--brand-primary-lighten"
        highlightColor="blue"
      />
      <MediaSection
        highlightText="Built by Immigrants,"
        mainText="For Immigrants"
        videoLink={BUILT_BY_IMMIGRANTS_VIDEO_LINK}
        isScaleVideo
      >
        <p>
          At Joblio, our mission is to transform lives through meaningful
          employment opportunities while fostering a more equitable global
          workforce. We empower both businesses and individuals by creating
          sustainable connections that go beyond traditional recruitment,
          ensuring every person has the chance to achieve their professional
          aspirations and contribute to organizational success.
        </p>
        <p>
          Our vision extends to a world where geographic boundaries and social
          barriers no longer limit human potential - a future where every
          talented individual can access dignified work opportunities, and where
          businesses thrive through diverse, engaged, and supported workforces.
          Through our innovative approach to workforce development and our
          commitment to human-centered employment practices, we're building
          lasting bridges between global talent and forward-thinking employers,
          creating positive change one career at a time.
        </p>
      </MediaSection>
      <Testimonials />
      <MediaAboutUs />
      <ContactUs />
    </>
  );
};

export default Home;
